import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { description } from './description.vanilla.mjs';

const ModalDescription = forwardRef(function ModalDescription2({ className: classNameFromProps, ...props }, ref) {
  const className = classNames(description, classNameFromProps);
  return /* @__PURE__ */ jsx(
    StyledDialogPrimitiveDescription,
    {
      "data-scope": "modal",
      "data-part": "description",
      className,
      ref,
      ...props
    }
  );
});
ModalDescription.toString = () => '[data-scope="modal"][data-part="description"]';
const StyledDialogPrimitiveDescription = styled(DialogPrimitive.Description);

export { ModalDescription };
//# sourceMappingURL=Description.mjs.map
